// Messages for operator/settings/OperatorImpersonation (auto-merged into the catalog).
export const en = {
  'operator.operator_impersonation.head': 'Impersonate operator — Operator',
  'operator.operator_impersonation.title': 'Impersonate operator',
  'operator.operator_impersonation.desc':
    'Act as another operator (one you outrank) to debug what they see. Start and exit are audited.',
  'operator.operator_impersonation.all_settings': 'All settings',
  'operator.operator_impersonation.active': 'You are currently acting as {email}.',
  'operator.operator_impersonation.active_hint':
    'Use “Exit impersonation” in the banner at the top of the app to return to your own account.',
  'operator.operator_impersonation.col.name': 'Name',
  'operator.operator_impersonation.col.email': 'Email',
  'operator.operator_impersonation.col.role': 'Role',
  'operator.operator_impersonation.col.action': 'Action',
  'operator.operator_impersonation.impersonate': 'Impersonate',
  'operator.operator_impersonation.empty': 'No operators you can impersonate.',
  'operator.operator_impersonation.note':
    'You can only impersonate operators below your role, and you get exactly their permissions — never more. Every session is time-boxed and audited.',
  // Modal
  'operator.operator_impersonation.modal.title': 'Impersonate {name}',
  'operator.operator_impersonation.modal.blurb_before': 'You’ll act as ',
  'operator.operator_impersonation.modal.blurb_after':
    ' — with exactly their permissions, never more. The session is time-boxed, shows a banner, and start & exit are audited.',
  'operator.operator_impersonation.modal.duration': 'Time limit',
  'operator.operator_impersonation.modal.minutes': '{count} minutes',
  'operator.operator_impersonation.reason_label': 'Reason',
  'operator.operator_impersonation.required': 'required',
  'operator.operator_impersonation.reason_placeholder':
    'e.g. Reproducing a bug reported by this operator',
  'operator.operator_impersonation.start': 'Start session',
  'operator.operator_impersonation.cancel': 'Cancel',
}

export const zhTW = {
  'operator.operator_impersonation.head': '模擬操作員 — 操作員',
  'operator.operator_impersonation.title': '模擬操作員',
  'operator.operator_impersonation.desc':
    '以另一位（你所管轄的）操作員身分操作，以偵錯他們所見的內容。開始與結束都會被稽核。',
  'operator.operator_impersonation.all_settings': '所有設定',
  'operator.operator_impersonation.active': '你目前正以 {email} 的身分操作。',
  'operator.operator_impersonation.active_hint':
    '使用應用程式頂部橫幅中的「結束模擬」即可返回你自己的帳號。',
  'operator.operator_impersonation.col.name': '姓名',
  'operator.operator_impersonation.col.email': '電子郵件',
  'operator.operator_impersonation.col.role': '角色',
  'operator.operator_impersonation.col.action': '操作',
  'operator.operator_impersonation.impersonate': '模擬',
  'operator.operator_impersonation.empty': '沒有可模擬的操作員。',
  'operator.operator_impersonation.note':
    '你只能模擬職級低於你的操作員，且只會取得他們的權限，絕不會更多。每次模擬都有時間限制並被稽核。',
  // Modal
  'operator.operator_impersonation.modal.title': '模擬 {name}',
  'operator.operator_impersonation.modal.blurb_before': '你將以 ',
  'operator.operator_impersonation.modal.blurb_after':
    ' 的身分操作 — 僅取得其權限，絕不會更多。工作階段有時間限制、會顯示橫幅，且開始與結束皆會被稽核。',
  'operator.operator_impersonation.modal.duration': '時間限制',
  'operator.operator_impersonation.modal.minutes': '{count} 分鐘',
  'operator.operator_impersonation.reason_label': '原因',
  'operator.operator_impersonation.required': '必填',
  'operator.operator_impersonation.reason_placeholder': '例如：重現這位操作員回報的問題',
  'operator.operator_impersonation.start': '開始工作階段',
  'operator.operator_impersonation.cancel': '取消',
}
